import React, { useEffect, useState, useRef,useCallback  } from 'react';
import axios from 'axios';
import ForceGraph2D from 'react-force-graph-2d';
import { API_BASE_URL } from '../../constants';
import { useParams } from 'react-router-dom';
import * as d3 from 'd3-force';
import ModeToggleButton from './ToggleButton'
const MindMap = () => {
  const { memberId } = useParams();
  const [graphData, setGraphData] = useState({ nodes: [], links: [] });
  const fgRef = useRef();

  const getNodeRadius = (node, graphData) => {
  switch (node.relationType) {
    case "parent":
      return 90;
    case "child":
      return 70;
    case "grandchild":
      return 50;
    case "descendant":
      return 40;
    case "spouse": {
  const spouseLink = graphData.links.find(l => {
    const sourceId = typeof l.source === "object" ? l.source.id : l.source;
    const targetId = typeof l.target === "object" ? l.target.id : l.target;
    return (
      l.label === "spouse" &&
      (sourceId === node.id || targetId === node.id)
    );
  });

  if (spouseLink) {
    const sourceId = typeof spouseLink.source === "object" ? spouseLink.source.id : spouseLink.source;
    const targetId = typeof spouseLink.target === "object" ? spouseLink.target.id : spouseLink.target;

    const partnerId = sourceId === node.id ? targetId : sourceId;
    const partner = graphData.nodes.find(n => n.id === partnerId);

    if (partner) {
      // spouse capped size (don’t let it get too big)
      return Math.min(getNodeRadius(partner, graphData) * 0.6, 40);
    }
  }

  return 20; // fallback default spouse size
}

    default:
      return 12;
  }
};


  // Configure forces after graphData loads
  useEffect(() => {
    if (fgRef.current) {
      // Collision force based on family size (avoid overlapping clusters)
      // fgRef.current.d3Force(
      //   'collision',
      //   d3.forceCollide(node => 40 + (node.childrenCount || 0) * 8) // bigger families push further
      // );
      // Collision force based on actual radius
fgRef.current.d3Force(
  'collision',
  d3.forceCollide(node => getNodeRadius(node, graphData) + 10) // add padding
);


      // Repulsion between all nodes
      const charge = fgRef.current.d3Force('charge');
      const linkForce = fgRef.current.d3Force('link');

      if(graphData.nodes.length > 20){
        if (charge) charge.strength(-400); // stronger repulsion

        // Custom link distance & strength
        if (linkForce) {
          linkForce
            .distance(link => {
              if (link.label === 'spouse') return 60; // keep spouses close

              // Find parent node
              const parentNode = graphData.nodes.find(
                n => n.id === (link.source.id || link.source) || n.id === (link.target.id || link.target)
              );
              const childrenCount = parentNode ? parentNode.childrenCount || 0 : 0;

              // Larger families = push children farther away
              return 160 + childrenCount * 50;
            })
            .strength(link => (link.label === 'spouse' ? 1.0 : 0.3)); // spouses strong, children looser
        }
      }
      else{
          if (charge) charge.strength(-120);
          if (linkForce) {
            linkForce.distance(link => {
              if (link.label === 'spouse') return 30;

              // Check if this child is directly next to spouse
              const isAdjacentToSpouse = graphData.links.some(
                l =>
                  l.label === 'spouse' &&
                  (l.source === link.source || l.target === link.source)
              );

              return isAdjacentToSpouse ? 140 : 100; // Slightly push child away if it's near spouse
            });
          }
      }
    }
  }, [graphData]);

  // // Fetch data
  // useEffect(() => {
  //   const fetchGraphData = async () => {
  //     try {
  //       const response = await axios.get(`${API_BASE_URL}family-graph/${memberId}/`);
  //       const rawData = response.data.data;
  //       console.log(rawData)
  //       // Normalize nodes
  //       const normalizedNodes = rawData.data.nodes.map(n => ({
  //         ...n,
  //         id: String(n.id),
  //         name: n.name || n.id,
  //         childrenCount: 0, // initialize
  //       }));

  //       // Normalize links
  //       const normalizedLinks = rawData.data.links.map(l => ({
  //         ...l,
  //         source: String(l.source),
  //         target: String(l.target),
  //       }));

  //       // Count children per parent
  //       normalizedLinks.forEach(l => {
  //         if (l.label === 'child') {
  //           const parent = normalizedNodes.find(n => n.id === l.source);
  //           if (parent) parent.childrenCount += 1;
  //         }
  //       });

  //       setGraphData({
  //         nodes: normalizedNodes,
  //         links: normalizedLinks,
  //       });
  //     } catch (error) {
  //       console.error('Error fetching graph data:', error);
  //     }
  //   };

  //   fetchGraphData();
  // }, [memberId]);
 const fetchGraphData = useCallback(async (id) => {
    try {
      const response = await axios.get(`${API_BASE_URL}family-graph/${id}/`);
      const rawData = response.data.data;

      // Normalize nodes
      const normalizedNodes = rawData.data.nodes.map(n => ({
        ...n,
        id: String(n.id),
        name: n.name || n.id,
        childrenCount: 0,
      }));

      // Normalize links
      const normalizedLinks = rawData.data.links.map(l => ({
        ...l,
        source: String(l.source),
        target: String(l.target),
      }));

      // Count children per parent
      normalizedLinks.forEach(l => {
        if (l.label === 'child') {
          const parent = normalizedNodes.find(n => n.id === l.source);
          if (parent) parent.childrenCount += 1;
        }
      });

      setGraphData({
        nodes: normalizedNodes,
        links: normalizedLinks,
      });

      // reset zoom & center
      // if (fgRef.current) {
      //   fgRef.current.zoomToFit(400);
      // }

    } catch (error) {
      console.error('Error fetching graph data:', error);
    }
  }, []);
   useEffect(() => {
    fetchGraphData(memberId);
  }, [memberId, fetchGraphData]);
  return (
    <div style={{ width: '100%', height: '100vh' }}>
      <ForceGraph2D
        ref={fgRef}
        graphData={graphData}
        nodeLabel="name"
        nodeAutoColorBy="group"
        minZoom={0.1}
        maxZoom={5}
        onNodeClick={(node) => {
          // fetch new graph for clicked member
          fetchGraphData(node.id);
        }}
        nodeCanvasObject={(node, ctx, globalScale) => {
          const label = node.name || node.id;
         

          const radius = getNodeRadius(node, graphData);
          const fontSize = radius * 0.2 * globalScale;
          ctx.font = `${fontSize}px Sans-Serif`;
          // Color nodes based on relationType
          let color = '#CCABD8';
          switch (node.relationType) {
            case 'parent':
              color = '#86E3CE';
              break;
            case 'child':
              color = '#D0E6A5';
              break;
            case 'grandchild':
              color = '#FFDD94';
              break;
            case 'spouse':
              color = '#FA897B';
              break;
          }

          // Draw circle
          ctx.beginPath();
          ctx.arc(node.x, node.y, radius, 0, 2 * Math.PI, false);
          ctx.fillStyle = color;
          ctx.fill();
          ctx.strokeStyle = '#000';
          ctx.lineWidth = 1;
          ctx.stroke();

          // Draw label
          ctx.fillStyle = 'black';
          ctx.textAlign = 'center';
          ctx.textBaseline = 'middle';
          ctx.fillText(label, node.x, node.y);
        }}
        linkLabel={link => link.label}
        linkColor={() => '#444'}
        linkDirectionalArrowLength={0}
        linkDirectionalArrowRelPos={1}
      />
      <ModeToggleButton
       member_id={memberId}
       setExpanded = {null}
       expanded = {null}
       mode={2} />
    </div>
  );
};

export default MindMap;
